import React from 'react';
import './Info.css';

const ContactInfo = ({ institucional }) => {
  return (
    <aside className="contato-info">
      <h3>{institucional.titulo}</h3>
      <p>{institucional.descricao}</p>
    </aside>
  );
};

export default ContactInfo;